import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import * as XLSX from 'xlsx';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import { history } from '../../../shared/configure-store';
import Api from '../../../libraries/api';
import AuthHelper from '../../../libraries/auth-helper';
import { saveAs } from 'file-saver';

require('dotenv').config();
const validator = new SimpleReactValidator({ locale: process.env.REACT_APP_LOCALE });

class Import extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},
            validationErrors: [],
            file: null,
            isManage: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Gudangemas - Impor Produk';

        const profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            const roles = profile['map-menu'].map(o => ({
                id: o.id,
                name: o.menu.name,
                isCreate: o.isCreate,
                isManage: o.isManage,
            }));

            const all = roles.filter(item => item.name === 'Daftar Produk');
            if (all.length > 0) {
                this.setState({ isManage: all[0] && all[0].isManage });
            }
        }
    }

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    }

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });

    handleGo = (link) => history.push(link);

    handleDownloadTemplate = () => {
        const headers = [
            'SKU',
            'Nama Produk',
            'Tipe Harga Produk',
            'Stok',            
            'Harga Reguler',
            'Harga REG 1',
            'Harga REG 2',
            'Harga REG 3',
            'Harga REG 4',
            'Harga REG 5',
            'Harga REG 6'
        ];

        const worksheetData = [headers];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ c: C, r: 0 });
            if (!worksheet[cellAddress]) continue;

            worksheet[cellAddress].s = {
                font: { bold: true },
                alignment: { horizontal: 'center' }
            };
        }

        worksheet['!cols'] = headers.map(header => ({
            wch: Math.max(header.length, 15)
        }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Template Produk");

        const fileName = `ge_products_import_template.xlsx`;
        XLSX.writeFile(workbook, fileName);
    };

    handleSelectFileToImport = (e) => {
        const file = e.target.files[0];
        if (!file) {
            this.showMessage(false, 'Format file yang anda pilih tidak dapat dipakai');
            return;
        }
        this.setState({ file });
    };

    readExcelFile = (file) => {
        return new Promise((resolve, reject) => {
            if (!file || file.size === 0) {
                reject('File kosong atau tidak valid.');
                return;
            }
    
            setTimeout(() => {
                const reader = new FileReader();
    
                reader.onload = (e) => {
                    try {
                        const data = e.target.result;
                        const workbook = XLSX.read(data, { type: 'binary' });
    
                        if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
                            reject('File tidak mengandung sheet yang valid.');
                            return;
                        }
    
                        const sheetName = workbook.SheetNames[0];
                        const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });
                        resolve(jsonData);
                    } catch (error) {
                        console.error('Error reading Excel file:', error);
                        reject('Error membaca file Excel. Pastikan file dalam format yang benar.');
                    }
                };
    
                reader.onerror = () => {
                    console.error('FileReader error:', reader.error);
                    reject('File tidak dapat dibaca. Silakan coba lagi dengan file lain.');
                };
    
                reader.readAsBinaryString(file);
            }, 500);
        });
    };

    validateExcelData = (excelData) => {
        const [headers, ...rows] = excelData;
        const validationErrors = [];
    
        const validRows = rows.filter(row => row[0]);
        if (validRows.length > 300) {
            validationErrors.push('Error: Maksimum data valid yang dikirim sebanyak 300 baris. Silakan perbaharui file Excel anda');
        }
    
        rows.forEach((row, rowIndex) => {
            const sku = row[0];
            const productName = row[1];
            const productSegment = row[2];
            const quantity = row[3] === "" || row[3] === null || row[3] === undefined ? null : row[3];
            const regularPrice = row[4] === "" || row[4] === null || row[4] === undefined ? null : parseFloat(row[4]);
            const regionalPrices = [row[5], row[6], row[7], row[8], row[9], row[10]].map(price => price === "" || price === null || price === undefined ? null : parseFloat(price));
    
            if (!sku && !productName && !productSegment && !quantity && !regularPrice && regionalPrices.every(price => !price)) {
                return;
            }
    
            if (!sku && (productName || productSegment || quantity || regularPrice || regionalPrices.some(price => price))) {
                validationErrors.push(`Baris ${rowIndex + 2}: SKU wajib diisi.`);
                return;
            }
    
            if (sku) {
                if (!productName) validationErrors.push(`Baris ${rowIndex + 2}: [SKU: ${sku}] Nama Produk wajib diisi.`);
                if (!productSegment) validationErrors.push(`Baris ${rowIndex + 2}: [SKU: ${sku}] Tipe Harga Produk wajib diisi.`);
                if (quantity === "" || quantity === null || quantity === undefined) validationErrors.push(`Baris ${rowIndex + 2}: [SKU: ${sku}] Stock wajib diisi. Boleh diisi dengan angka 0.`);
                if (productSegment === 'ALL' || productSegment === 'INDIVIDU') {
                    if (regularPrice === "" || regularPrice === null || regularPrice === undefined) {
                        validationErrors.push(`Baris ${rowIndex + 2}: [SKU: ${sku}] Harga Reguler wajib diisi. Boleh diisi dengan angka 0.`);
                    }
                }

                if (productSegment === 'ALL' || productSegment === 'CORPORATE') {
                    if (regionalPrices.some(price => price === null || price === undefined || price === "")) {
                        validationErrors.push(`Baris ${rowIndex + 2}: [SKU: ${sku}] Semua Harga Regional harus diisi. Boleh diisi dengan angka 0.`);
                    }
                }
            }
        });
    
        return validationErrors;
    };

    mapExcelDataToAPIFormat = (excelData) => {
        const [headers, ...rows] = excelData;
    
        return rows
            .filter(row => row[0])
            .map((row) => {
                const productSegment = row[2] ? row[2].toUpperCase() : '';
                const regularPrice = productSegment === 'CORPORATE' ? '0' : String(row[4] || 0);
                const regional = productSegment === 'INDIVIDU' 
                    ? []
                    : [
                        { regional_code: 'REG 1', price: String(row[5] || 0) },
                        { regional_code: 'REG 2', price: String(row[6] || 0) },
                        { regional_code: 'REG 3', price: String(row[7] || 0) },
                        { regional_code: 'REG 4', price: String(row[8] || 0) },
                        { regional_code: 'REG 5', price: String(row[9] || 0) },
                        { regional_code: 'REG 6', price: String(row[10] || 0) },
                    ];
    
                return {
                    sku: row[0],
                    product_name: row[1],
                    product_segment: productSegment,
                    quantity: parseInt(row[3]) || 0,
                    regular_price: regularPrice,
                    regional: regional,
                };
            });
    };

    downloadErrorFile = (validationErrors) => {
        const timestamp = moment().format('DDMMYYYYHHmmss');
        const fileName = `ge_products_import_error_${timestamp}`;

        // Option 1: Download as .txt
        const textContent = validationErrors.join('\n');
        const blob = new Blob([textContent], { type: 'text/plain;charset=utf-8' });
        saveAs(blob, `${fileName}.txt`);

        // Option 2: Download as .xlsx
        /* const worksheet = XLSX.utils.json_to_sheet(validationErrors.map(error => ({ Error: error })));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'validationErrors');
        XLSX.writeFile(workbook, `${fileName}.xlsx`); */
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        if (!validator.allValid()) {
            return this.setState({ validationErrors: validator.getErrorMessages() });
        }

        const file = this.state.file;
        if (!file) {
            this.showMessage(false, 'Please select a file to upload.');
            return;
        }
        
        this.setState({ errors: {}, validationErrors: [], loadingButton: true });

        try {
            const excelData = await this.readExcelFile(file);
            const validationErrors = this.validateExcelData(excelData);

            if (validationErrors.length > 0) {
                this.setState({ loading: false, loadingButton: false, validationErrors: validationErrors, file: null });
                this.showMessage(false, 'Ada kesalahan dalam input dan format data yang anda kirimkan, silakan periksa daftar catatan error yang di download otomatis');
                this.downloadErrorFile(validationErrors);

                const fileInput = document.querySelector('input[type="file"]');
                if (fileInput) fileInput.value = '';
                return;
            }

            const mappedData = this.mapExcelDataToAPIFormat(excelData);

            Api.put('/product/update/bulk', mappedData)
                .then((resp) => {
                    if (resp.status === 200) {
                        // history.push('/products');
                        this.showMessage(true, 'Produk berhasil diimpor');
                    } else {
                        this.showMessage(false, resp.message[0]);
                    }
                })
                .catch((err) => {
                    console.error('Error submitting file:', err);
                    this.showMessage(false, 'Error ketika memproses import data');
                })
                .finally(() => this.setState({ loading: false, loadingButton: false }));
        } catch (error) {
            console.error('Error processing file:', error);
            this.showMessage(false, 'Terjadi kesalahan ketika memproses file anda.');
            this.setState({ loading: false, loadingButton: false });
        }
    };

    render() {
        const { loadingButton, file, errors, isManage } = this.state;
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Impor</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/products">Produk</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Impor</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className="mb-0">Impor Produk</h2>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-between content-filter mt-4">
                            <div className="col-md-12 mb-4 p-3">
                                <h5 className="mb-3"><b>Tutorial Impor Produk</b></h5>
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <div className="d-flex align-items-center">
                                            <div className="step-icon mr-3">
                                                <i className="fas fa-download"></i>
                                            </div>
                                            <div>
                                                <strong>Langkah 1: Download Template</strong>
                                                <p>Klik tombol "Download" untuk mendapatkan file Excel yang berisi daftar produk.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <div className="d-flex align-items-center">
                                            <div className="step-icon mr-3">
                                                <i className="fas fa-edit"></i>
                                            </div>
                                            <div>
                                                <strong>Langkah 2: Edit File Excel</strong>
                                                <div>
                                                    Isi perubahan data produk sesuai kolom yang tersedia. Data yang diubah umumnya di kolom Stok Produk, Harga Reguler, atau Harga setiap Regional.
                                                    <br />
                                                    <ul className="pl-3">
                                                        <li>Isi Kolom "Tipe Harga Produk" dengan salah satu dari kata "ALL", "INDIVIDU", atau "CORPORATE"</li>
                                                        <li>Jika Tipe Harga Produk diisi "ALL" maka Harga Reguler dan Harga Regional wajib diisi</li>
                                                        <li>Jika Tipe Harga Produk diisi "INDIVIDU" maka Harga Reguler wajib diisi</li>
                                                        <li>Jika Tipe Harga Produk diisi "CORPORATE" maka Harga Regional wajib diisi</li>
                                                        <li>Kolom Harga Reguler dan Harga Regional (Harga REG 1 s/d Harga REG 6) menggunakan angka tanpa pemisah ribuan (contoh: 100000).</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex align-items-center">
                                            <div className="step-icon mr-3">
                                                <i className="fas fa-upload"></i>
                                            </div>
                                            <div>
                                                <strong>Langkah 3: Unggah File</strong>
                                                <p>Pilih file Excel yang telah diedit dan klik tombol "Impor".</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-between content-filter mt-4">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label><b>Download Template Produk</b></label>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className="ml-3 mb-3"
                                        onClick={this.handleDownloadTemplate}
                                        startIcon={<i className="fas fa-download"></i>}
                                    >
                                        Download
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <form name="import" id="import" className="row mt-4" noValidate>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Impor Data Produk dari File</label>
                                    <TextField
                                        variant="outlined"
                                        type="file"
                                        id="file"
                                        name="products"
                                        className="products"
                                        onChange={this.handleSelectFileToImport}
                                    />
                                    {validator.message('file', file, 'required')}
                                    <div className="text-danger">{errors.file}</div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Button
                                    className="mr-3"
                                    variant="contained"
                                    onClick={() => this.handleGo('/products')}
                                >
                                    Batal
                                </Button>
                                {isManage && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleSubmit}
                                        disabled={loadingButton || !file}
                                    >
                                        Impor {loadingButton && <i className="fa fa-spinner fa-spin"></i>}
                                    </Button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default Import;